import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule, SearchModule } from '@northfork/ng-basics'
import { HotkeysHelpComponent } from './hotkeys-help/hotkeys-help.component'
import { HotkeysService } from './hotkeys.service'
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    NgbModalModule,
    NgbTooltipModule,
    SearchModule,
    GenericComponentsModule,
  ],
  declarations: [HotkeysHelpComponent],
  exports: [HotkeysHelpComponent],
})
export class HotkeysModule {
  static forRoot(): ModuleWithProviders<HotkeysModule> {
    return {
      ngModule: HotkeysModule,
      providers: [HotkeysService],
    }
  }
}
